import { render, staticRenderFns } from "./df-section-special.vue?vue&type=template&id=78b30946&"
import script from "./df-section-special.ts?vue&type=script&lang=js&"
export * from "./df-section-special.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports